import React from 'react'
import {
    StyledCardImage,
    StyledCardImageContainer,
    StyledContentCard,
    StyledLinkWrapper,
    StyledText,
    StyledTextContainer,
    StyledTimeToRead,
} from './ContentCard.styled'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import {
    CardItem,
    CollectionEvent,
    createCardClickedEvent,
    isPublicationCardItem,
    toLinkWithHint,
} from '@news-mono/web-common'

export type CardType = 'large' | 'medium' | 'small'

export interface ContentCardProps {
    item: MaybeLoaded<CardItem>
    cardNumber: number
    cardType: CardType
    onEvent: (event: CollectionEvent) => void
    gridAreaName?: string
    displayRightSeparator?: boolean
}

const getImageWidth = (cardType: CardType) => {
    switch (cardType) {
        case 'small':
            return '350px'
        case 'medium':
            return '740px'
        case 'large':
            return '740px'
    }
}

export const ContentCard: React.FC<ContentCardProps> = ({
    item,
    cardNumber,
    cardType,
    onEvent,
    gridAreaName,
    displayRightSeparator,
}) => {
    function linkClicked(
        e: React.MouseEvent<HTMLElement>,
        item: MaybeLoaded<CardItem>,
        cardNumber: number,
    ) {
        if (!item.loaded) {
            e.preventDefault()
            return
        }
        onEvent(
            createCardClickedEvent(
                onEvent,
                item.result,
                'InternalPortrait',
                'Portrait',
                cardNumber,
                'InlineRelatedCollection',
            ),
        )
    }

    if (item.loaded && isPublicationCardItem(item.result)) {
        const timeToRead = item?.result?.readTimeMinutes
            ? `${Math.ceil(item.result.readTimeMinutes)} min read`
            : ''

        return (
            <StyledLinkWrapper
                to={toLinkWithHint(item)}
                onClick={(event) => {
                    linkClicked(event, item, cardNumber)
                }}
                gridAreaName={gridAreaName}
            >
                <StyledContentCard
                    cardType={cardType}
                    displayRightSeparator={displayRightSeparator}
                >
                    <StyledTextContainer cardType={cardType}>
                        <StyledText
                            item={{
                                loaded: true,
                                result: item.result,
                            }}
                            fontScale={1}
                            onEvent={onEvent}
                            teaserMode={
                                cardType === 'small' ? 'hidden' : 'visible'
                            }
                            kickerMode={'hidden'}
                        />
                        {timeToRead && (
                            <StyledTimeToRead>{timeToRead}</StyledTimeToRead>
                        )}
                    </StyledTextContainer>
                    <StyledCardImageContainer cardType={cardType}>
                        <StyledCardImage
                            item={{
                                loaded: true,
                                result: item.result,
                            }}
                            imageWidths={{
                                mobile: getImageWidth(cardType),
                                tablet: getImageWidth(cardType),
                                desktop: getImageWidth(cardType),
                                fallbackWidth: 740,
                            }}
                            hasBackground={true}
                            onEvent={onEvent}
                            mediaMode={'default'}
                            fixedRatio={'16:9'}
                        />
                    </StyledCardImageContainer>
                </StyledContentCard>
            </StyledLinkWrapper>
        )
    } else {
        return null
    }
}
